import { useEffect, useRef, useState } from 'react'
import { Button } from 'antd'
import { assinarCarregamento } from 'utils/carregamentoGlobal'
import MarcaYrm from './MarcaYrm'
import * as S from './styles'

// Fica dentro da página (o menu e o topo continuam livres) e só aparece quando há o que
// esperar: o que está no cache nem chega aqui (utils/carregamentoGlobal).
// Espera curta: só uma barra fina dourada. Espera maior: página desfocada com a marca.
// Não bloqueia cliques: se uma busca travar, a pessoa continua usando a tela.
// Para ver com calma: abra qualquer tela com ?verCarregamento=1.
const BARRA_MS = 300
const DESFOQUE_MS = 700
const MINIMO_MS = 350

function CarregamentoGlobal() {
  const [fase, setFase] = useState(null) // null | 'barra' | 'desfoque'
  const [previa, setPrevia] = useState(() => new URLSearchParams(window.location.search).has('verCarregamento'))
  const tempos = useRef({ barra: null, desfoque: null, fechar: null, desde: 0 })

  useEffect(() => {
    const t = tempos.current
    const parar = assinarCarregamento((quantas) => {
      if (quantas > 0) {
        clearTimeout(t.fechar)
        t.fechar = null
        if (!t.barra && !t.desde) {
          t.barra = setTimeout(() => {
            t.barra = null
            t.desde = Date.now()
            setFase('barra')
            t.desfoque = setTimeout(() => { t.desfoque = null; t.desde = Date.now(); setFase('desfoque') }, DESFOQUE_MS - BARRA_MS)
          }, BARRA_MS)
        }
        return
      }
      clearTimeout(t.barra)
      t.barra = null
      if (!t.desde || t.fechar) return
      t.fechar = setTimeout(() => {
        t.fechar = null
        t.desde = 0
        clearTimeout(t.desfoque)
        t.desfoque = null
        setFase(null)
      }, Math.max(0, MINIMO_MS - (Date.now() - t.desde)))
    })
    return () => { parar(); clearTimeout(t.barra); clearTimeout(t.desfoque); clearTimeout(t.fechar) }
  }, [])

  const aberto = fase === 'desfoque' || previa

  useEffect(() => {
    document.body.classList.toggle('yrm-carregando', aberto)
    return () => document.body.classList.remove('yrm-carregando')
  }, [aberto])

  useEffect(() => {
    if (!previa) return undefined
    const fecharComEsc = (e) => { if (e.key === 'Escape') setPrevia(false) }
    window.addEventListener('keydown', fecharComEsc)
    return () => window.removeEventListener('keydown', fecharComEsc)
  }, [previa])

  if (!aberto) return fase === 'barra' ? <S.Barra role='progressbar' aria-label='Carregando' /> : null
  return (
    <S.Global role='status' aria-label='Carregando'>
      <MarcaYrm className='yrm-marca--global' />
      <span className='texto'>Carregando</span>
      {previa && <Button style={{ pointerEvents: 'auto', marginTop: 24 }} onClick={() => setPrevia(false)}>Fechar prévia</Button>}
    </S.Global>
  )
}

export default CarregamentoGlobal
